import React, { useState, useEffect } from 'react'
import { getInvoiceDetail } from './portalApi'
import createPDFInvoiceUseCase from 'invoices/services/createPDFInvoice'
import { calculateTotalInvoice } from 'invoices/services/detail/calculateInvoicesInfo'
import { Button, IconButton } from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility'
import GetAppIcon from '@material-ui/icons/GetApp'
import CloseIcon from '@material-ui/icons/Close'
import { font, dark } from './portalStyles'
import { translations } from './portalI18n'

const renderDate = (ts, lang) => {
    if (!ts) return '—'
    return new Date(ts).toLocaleDateString(lang === 'en' ? 'en-GB' : 'es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

// invoice._detail puede venir precargado desde el dashboard (cache).
// Si no viene, se fetcha aquí como fallback.
const PortalInvoiceModal = ({ invoice, onClose, lang = 'es' }) => {
    const t = translations[lang]
    const [detail, setDetail] = useState(invoice._detail || null)
    const [loading, setLoading] = useState(!invoice._detail)
    const [downloading, setDownloading] = useState(false)

    useEffect(() => {
        if (invoice._detail) return  // ya tenemos el detalle, no hace falta fetch
        getInvoiceDetail(invoice.id).then(d => {
            setDetail(d)
            setLoading(false)
        })
    }, [invoice.id, invoice._detail])

    const handleDownload = async (operation) => {
        if (!detail) return
        setDownloading(true)
        try {
            await createPDFInvoiceUseCase({
                invoiceData: invoice,
                initialInvoiceDetailData: detail,
                operation,
                isProforma: invoice.type === 'Proforma',
            })
        } finally {
            setDownloading(false)
        }
    }

    const invoiceLabel = invoice.type === 'Proforma' ? t.proforma : t.invoice

    return (
        <div style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000, padding: '20px', fontFamily: font,
        }}>
            <div style={{
                background: dark.surface,
                border: `1px solid ${dark.border}`,
                borderRadius: '12px',
                padding: '28px', width: '100%', maxWidth: '480px',
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '18px', color: dark.text }}>
                            {invoiceLabel} #{invoice.numInvoice}
                        </h2>
                        <p style={{ margin: '4px 0 0', color: dark.text2, fontSize: '13px' }}>
                            {renderDate(invoice.invoiceDate, lang)}
                        </p>
                    </div>
                    <IconButton onClick={onClose} size="small" style={{ color: dark.text2 }}>
                        <CloseIcon style={{ fontSize: 18 }} />
                    </IconButton>
                </div>

                {loading ? (
                    <p style={{ color: dark.text2, textAlign: 'center' }}>{t.loading}</p>
                ) : (
                    <>
                        <div style={{ background: dark.surface2, borderRadius: '8px', padding: '14px', marginBottom: '20px', border: `1px solid ${dark.border}` }}>
                            {detail?.data?.map((item, i) => (
                                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: dark.text, marginBottom: '6px' }}>
                                    <span style={{ flex: 1, marginRight: '12px', color: dark.text2 }}>
                                        {item.description || item.reference}
                                        {item.units > 1 ? ` ×${item.units}` : ''}
                                    </span>
                                    <span style={{ fontWeight: '600', flexShrink: 0, color: dark.text }}>{Number(item.totalPrice || 0).toFixed(2)} €</span>
                                </div>
                            ))}
                            <div style={{ borderTop: `1px solid ${dark.border}`, paddingTop: '10px', marginTop: '10px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', fontSize: '15px', fontWeight: '700', color: dark.text }}>
                                    <span>
                                        {t.total}
                                        <span style={{ fontSize: '11px', fontWeight: 400, color: dark.text2, marginLeft: 6 }}>(IVA incluido)</span>
                                    </span>
                                    <span>
                                        {detail?.data?.length
                                            ? calculateTotalInvoice(detail.data, invoice.ivaPercent).total.toFixed(2)
                                            : Number(invoice.totalPrice || 0).toFixed(2)
                                        } €
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                            <Button
                                variant="contained"
                                onClick={() => handleDownload('view')}
                                disabled={downloading}
                                startIcon={<VisibilityIcon style={{ fontSize: 16 }} />}
                                style={{ flex: 1, textTransform: 'none', fontWeight: 600, background: '#f0f0f0', color: '#111', borderRadius: 6 }}
                            >
                                {downloading ? t.generating : t.viewPDF}
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={() => handleDownload('save')}
                                disabled={downloading}
                                startIcon={<GetAppIcon style={{ fontSize: 16 }} />}
                                style={{ flex: 1, textTransform: 'none', fontWeight: 600, color: dark.text, borderColor: dark.border, borderRadius: 6 }}
                            >
                                {t.download}
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default PortalInvoiceModal
